"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OktonGridFooter = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const lu_1 = require("react-icons/lu");
const grid_1 = require("./grid");
const OktonGridFooter = ({ total, page, setPage, pageSize, setPageSize, pageCount, itemLabel = 'item', itemLabelPlural, hideTotal = false, hidePageSize = false, pageSizeOptions = grid_1.OKTON_PAGE_SIZES, }) => {
    const color = (0, react_1.useColorModeValue)('gray.700', 'white');
    const hasPrevious = page > 0;
    const hasNext = page < pageCount - 1;
    return (react_2.default.createElement(react_1.Flex, { justify: "space-between", align: "center", px: "5", py: "3", borderTopWidth: "1px", flexWrap: "wrap", gap: "2" },
        !hideTotal ? (react_2.default.createElement(react_1.Text, { fontSize: "sm", color: "gray.500" },
            total,
            ' ',
            total === 1
                ? itemLabel
                : itemLabelPlural !== null && itemLabelPlural !== void 0 ? itemLabelPlural : `${itemLabel}s`)) : null,
        react_2.default.createElement(react_1.HStack, { spacing: 2, ml: hideTotal ? 'auto' : undefined },
            !hidePageSize ? (react_2.default.createElement(react_2.default.Fragment, null,
                react_2.default.createElement(react_1.Text, { fontSize: "sm", color: "gray.500" }, "Linhas por p\u00E1gina:"),
                react_2.default.createElement(react_1.Select, { name: "page-size", w: "20", size: "sm", rounded: "lg", color: color, value: pageSize, onChange: event => setPageSize(Number(event.target.value)) }, pageSizeOptions.map(size => (react_2.default.createElement("option", { key: size, value: size }, size)))))) : null,
            react_2.default.createElement(react_1.Text, { fontSize: "sm", color: "gray.500", whiteSpace: "nowrap" },
                page + 1,
                " de ",
                pageCount),
            react_2.default.createElement(react_1.IconButton, { variant: "ghost", size: "sm", "aria-label": "Primeira p\u00E1gina", icon: react_2.default.createElement(lu_1.LuChevronsLeft, {
                    size: 18,
                }), onClick: () => setPage(0), isDisabled: !hasPrevious }),
            react_2.default.createElement(react_1.IconButton, { variant: "ghost", size: "sm", "aria-label": "P\u00E1gina anterior", icon: react_2.default.createElement(lu_1.LuChevronLeft, {
                    size: 18,
                }), onClick: () => setPage(page - 1), isDisabled: !hasPrevious }),
            react_2.default.createElement(react_1.IconButton, { variant: "ghost", size: "sm", "aria-label": "Pr\u00F3xima p\u00E1gina", icon: react_2.default.createElement(lu_1.LuChevronRight, {
                    size: 18,
                }), onClick: () => setPage(page + 1), isDisabled: !hasNext }),
            react_2.default.createElement(react_1.IconButton, { variant: "ghost", size: "sm", "aria-label": "\u00DAltima p\u00E1gina", icon: react_2.default.createElement(lu_1.LuChevronsRight, {
                    size: 18,
                }), onClick: () => setPage(pageCount - 1), isDisabled: !hasNext }))));
};
exports.OktonGridFooter = OktonGridFooter;
//# sourceMappingURL=GridFooter.js.map